import * as preact from "preact";

import permissions from "../foundation/utils/permissions";

function withUserPermissionsContext(Component) {
    return class PermissionsContextProvider extends preact.Component {
        getChildContext() {
            const { userRole } = this.props;
            if (!userRole) {
                return null;
            }

            const roleObject = { role: userRole };
            return {
                canUpdateProject: permissions.canUpdateProject(roleObject),
                canManageScreens: permissions.canManageScreens(roleObject),
                canMoveScreens: permissions.canMoveScreens(roleObject),
                canCreateApprovals: permissions.canCreateApprovals(roleObject)
            };
        }

        render() {
            const passedProps = Object.assign({}, this.props);
            delete passedProps.componentRef;
            // TODO: use ref forwarding after react migration
            return preact.h(Component, Object.assign({}, passedProps, { ref: this.props.componentRef }));
        }
    };
}

export default withUserPermissionsContext;
